<template>
  <div>
    <div v-if="decryptedText == null">[ENCRYPTED]</div>
    <div style="cursor: pointer;" v-if="decryptedText != null" @click="copyDecryptedText">{{ decryptedText }}</div>
    <div style="display: inline-block;
    padding: .5rem;
background: #fff;
box-shadow: 0px 1px 5px rgba(0,0,0,.15);
font-weight: bold;
border-radius: 5px;
margin: 10px 0px;" v-if="copySucceeded == true">Copied!</div>
    <br>
    <textarea name="decrypt" placeholder="Enter encryption token here to decrypt." v-model="privateKey"></textarea>
    <button class="button" @click="decrypt">Decrypt</button>
  </div>
</template>

<script>
import Api from '@/Api.js';

export default {
  name: 'EncryptedField',
  props: [
    'encryptedText'
  ],
  data() {
    return {
      privateKey: '',
      decryptedText: null,
      copySucceeded: false
    };
  },
  methods: {
    decrypt() {
      Api.post(
        'encryption/decrypt',
        {
          privateKey: this.privateKey,
          encryptedText: this.encryptedText
        }
      ).then(response => {
        this.decryptedText = response.data;
      });
    },
    copyDecryptedText() {
      this.$copyText(this.decryptedText).then(() => {
        this.copySucceeded = true;
      });
    }
  },
  mounted() {
    console.log(this.encryptedText);
  }
}
</script>

<style>

</style>